var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "71px",
    viewBox: "0 0 65 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_ficha") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kiosko",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ficha",
    transform: "translate(-2016, -1404)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_ficha",
    transform: "translate(2016, 1404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4673913,2.84 C63.4173913,2.84 65,4.4304 65,6.39 L65,67.45 C65,69.4096 63.4173913,71 61.4673913,71 L3.5326087,71 C1.5826087,71 0,69.4096 0,67.45 L0,6.39 C0,4.4304 1.5826087,2.84 3.5326087,2.84 L14.1304348,2.84 L14.1304348,0 L16.9565217,0 L16.9565217,2.84 L31.0869565,2.84 L31.0869565,0 L33.9130435,0 L33.9130435,2.84 L48.0434783,2.84 L48.0434783,0 L50.8695652,0 L50.8695652,2.84 L61.4673913,2.84 Z M50.8695652,31.24 L14.1304348,31.24 L14.1304348,28.4 L50.8695652,28.4 L50.8695652,31.24 Z M2.82608696,19.88 L62.173913,19.88 L62.173913,67.45 C62.173913,67.8476 61.8630435,68.16 61.4673913,68.16 L3.5326087,68.16 C3.13695652,68.16 2.82608696,67.8476 2.82608696,67.45 L2.82608696,19.88 Z M62.173913,6.39 C62.173913,5.9924 61.8630435,5.68 61.4673913,5.68 L50.8695652,5.68 L50.8695652,11.36 L48.0434783,11.36 L48.0434783,5.68 L33.9130435,5.68 L33.9130435,11.36 L31.0869565,11.36 L31.0869565,5.68 L16.9565217,5.68 L16.9565217,11.36 L14.1304348,11.36 L14.1304348,5.68 L3.5326087,5.68 C3.13695652,5.68 2.82608696,5.9924 2.82608696,6.39 L2.82608696,17.04 L62.173913,17.04 L62.173913,6.39 Z M14.1304348,36.92 L45.2173913,36.92 L45.2173913,39.76 L14.1304348,39.76 L14.1304348,36.92 Z M50.8695652,45.44 L14.1304348,45.44 L14.1304348,48.28 L50.8695652,48.28 L50.8695652,45.44 Z M14.1304348,53.96 L45.2173913,53.96 L45.2173913,56.8 L14.1304348,56.8 L14.1304348,53.96 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsWhite);
export default __webpack_public_path__ + "static/media/details-white.192481afab25515084659ba822522133.svg";
export { ForwardRef as ReactComponent };